import { ProLightClock } from '@nexelem/icons/ProLightClock';
import { IconButton, Popover } from '@nexelem/components';
import { Control, useFormContext } from 'react-hook-form';
import clsx from 'clsx';
import { TaskStatus } from '@nexelem/graphne-api';
import { FormCalendarInput, FormTextInput } from '@nexelem/form-components';
import { AddToPlanFormSchema } from './getAddToPlanFormSchema';
import { useCustomTranslation } from '../../../../../../hooks';
import { Checkbox, FormControlLabel } from '@nexelem/deprecated-theme';
import { startedStatuses } from '../constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion, faLock } from '@fortawesome/pro-light-svg-icons';

type StartAndEndDateInputProps = {
  control: Control<AddToPlanFormSchema>;
  size: 'small' | 'big';
  status: TaskStatus;
};

export const StartAndEndDateInput = ({ size = 'big', status }: StartAndEndDateInputProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.taskDetailsDrawer');
  const { register, watch } = useFormContext<AddToPlanFormSchema>();

  const hasStarted = startedStatuses.includes(status);
  const startLabel = hasStarted ? tWrapper('productionStart') : tWrapper('estimatedStart');
  const endLabel = hasStarted ? tWrapper('productionEnd') : tWrapper('estimatedEnd');

  return (
    <>
      <div className={clsx('flex items-end gap-6', { 'pr-6': size !== 'small' })}>
        <FormCalendarInput required className="max-w-45" label={startLabel} name="start.date" />
        <FormTextInput
          required
          maxWidth={100}
          name="start.time"
          placeholder="00:00"
          StartIcon={ProLightClock}
          type="time"
        />
      </div>
      <div>
        <div className={clsx('flex items-end gap-6', { 'pr-6': size !== 'small' })}>
          <FormCalendarInput disabled className="max-w-45" label={endLabel} name="end.date" />
          <FormTextInput
            disabled
            maxWidth={100}
            name="end.time"
            placeholder="00:00"
            StartIcon={ProLightClock}
            type="time"
          />
        </div>
        <div className="mt-2 flex items-center pl-3">
          <div className="flex items-center gap-2">
            <FormControlLabel
              {...register('blockedStart')}
              className="mr-0"
              control={<Checkbox disableRipple checked={watch('blockedStart')} />}
              label={
                <div className="flex items-center gap-2 font-normal">
                  <FontAwesomeIcon className="h-5!" icon={faLock} />
                  <span className="text-s16">{tWrapper('block')}</span>
                </div>
              }
            />
          </div>
          <Popover.Root>
            <Popover.Trigger>
              <IconButton Icon={<FontAwesomeIcon icon={faCircleQuestion} />} />
            </Popover.Trigger>
            <Popover.Content className="max-w-60">{tWrapper('popperContent')}</Popover.Content>
          </Popover.Root>
        </div>
      </div>
    </>
  );
};
